export { default as DefaultPage } from './DefaultPage';



// WEBPACK FOOTER //
// ./src/features/acesso-negado/index.js